import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import Modal from 'components/modal';
import { deleteAttachment, deleteFolder } from './api';

export default function DeletionConfirmation({ attachment, folder, show, onClose, onDelete }) {
  function deleteRecord() {
    if (attachment) {
      deleteAttachment(attachment);
    } else {
      deleteFolder(folder);
    }

    onDelete(attachment || folder);
    onClose();
  }

  return (
    <Modal show={show} onClose={onClose}>
      <Modal.Header closeButton>
        Delete {attachment ? 'attachment' : 'folder'}
      </Modal.Header>

      <Modal.Body>
        Are you sure you want to delete
        <b>{` ${attachment ? attachment.displayName : folder.name}`}</b>
        {folder && ' and all of its contents'}?
        This can not be undone.
      </Modal.Body>

      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onClose} />
        <Button aria-label="delete" label="Delete" variant="destructive" onClick={deleteRecord}/>
      </Modal.Footer>
    </Modal>
  );
}

DeletionConfirmation.propTypes = {
  attachment: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
  }),
  folder: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
